import { TimeSeriesData } from '../dto/common/response/time-series-response.dto';
import {
  CubeTimeDimensionGranularity,
  Weekdays,
} from '../enum/cube-schema.enum';
import { compareDates, getFirstDayOfWeek } from './datetime.helper';

export const formatDuration = (
  duration: number,
  showSeconds = true,
  showMinutes = true
) => {
  duration = duration / 1000;
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = Math.floor((duration % 3600) % 60);
  if (!showMinutes) return hours + 'h';
  let durationArrayString = `${hours > 0 ? hours + 'h' : ''} ${
    (hours > 0 && showSeconds) || minutes > 0 ? minutes + 'm' : ''
  } ${showSeconds ? seconds + 's' : ''}`
    .replace(/\b0(m|s|h)/, '') // replace all instances of 0 h/m/s with empty string
    .trim()
    .split(/\s+/); // split by any amount of whitespace characters

  if (!durationArrayString.some(Boolean)) {
    if (showSeconds) {
      durationArrayString = ['0s'];
    } else {
      durationArrayString = ['0m'];
    }
  }
  const durationString =
    durationArrayString.length > 2
      ? durationArrayString.slice(0, -1).join(' ').trim()
      : durationArrayString.join(' ').trim();

  return durationString.trim();
};

export const calculateDeviation = (
  operator: number,
  denominator: number
): number => {
  if (operator === 0 || denominator === 0) return 0;
  const percentage =
    100 * ((operator - denominator) / (denominator > 0 ? denominator : 1));
  return (
    (percentage < 0
      ? -Math.round(Math.abs(percentage))
      : Math.round(percentage)) || 0
  );
};

export const calculateAverage = (
  operator: number,
  denominator: number
): number => {
  if (operator === 0 || denominator === 0) return 0;
  return operator / denominator;
};

export const fillEmptyDatesForTimeSeries = (
  startDate: string,
  endDate: string,
  granularity: string,
  timeSeries: TimeSeriesData[],
  weekday?: string
): TimeSeriesData[] => {
  const timeSeriesCopy = [...timeSeries];
  const dayDifference: number = weekday
    ? 7
    : granularity === CubeTimeDimensionGranularity.Week
    ? 7
    : 1;
  const firstDay: Date = weekday
    ? getFirstDayOfWeek(startDate, endDate, weekday)
    : granularity === CubeTimeDimensionGranularity.Week
    ? getFirstDayOfWeek(startDate, endDate, Weekdays.Monday)
    : new Date(startDate);
  const lastDay = new Date(endDate);
  const dates = timeSeriesCopy.map((s) => s.date);

  for (
    let day = firstDay;
    day <= lastDay;
    day.setDate(day.getDate() + dayDifference)
  ) {
    if (!dates.includes(day.toISOString().slice(0, 10))) {
      timeSeriesCopy.push({ date: day.toISOString().slice(0, 10), value: 0 });
    }
  }

  timeSeriesCopy.sort(compareDates);

  return timeSeriesCopy;
};

export const milliSecondsToMinutes = (milliseconds: number): number => {
  return milliseconds / 600000;
};

export const milliSecondsToHours = (milliseconds: number): number => {
  return milliseconds / 3600000;
};
